/*
 * Public API Surface of client
 */

export * from './lib/backoffice.module';
export * from './lib/backoffice-api-client';
